import React, { useContext, useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";

import { ChangeAuthRequisaMaterial, getAutorizacionesRM } from "../../../../../../API/Compras/Autorizaciones/AutorizacionesRequest";
import IngresosBodegaCrud from "../../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";

const ListadoRequisasMaterialesDet = ({
  listadoDet,
  // toast,
  setIngresoEdit,
  setShowDialog,
  setOrdenDialog,
  selectedDetalle,
  setSelectedDetalle,
  getInfo,
  IdPermisoGeneral,
  MateriaPrima,
  Referencia
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  
  const [loading, setLoading] = useState(false);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [showDialog2, setShowDialog2] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [habilitar, setHabilitar] = useState(false);
  const [orderToShow, setOrderToShow] = useState(null);



  // ACCESOS FINANZAS PARA OCULTAR PRECIOS
  const [hiddenVerPrecios, setHiddenVerPrecios] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(29)
  );

  //ACCESO PARA LIBERAR REQUISAS MATERIALES
  const [hiddenliberarRequisaM, setHiddenLiberarRequisaM] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(35)
  );

  //ACCESO PARA APROBAR RRHH
  const [hiddenAprobarRRHH, setHiddenAprobarRRHH] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(36)
  );

    //ACCESO PARA APROBAR MASS
  const [hiddenAprobarMASS,setHiddenAprobarMASS] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(37)
  );

  const obtenerAutorizaciones = async () => {
    const autorizacionesData = await getAutorizacionesRM();
    if(IdPermisoGeneral !== undefined){
      setAutorizaciones(autorizacionesData.filter((autorizacion) => autorizacion.IdPermisoGeneral === IdPermisoGeneral ));
    }else{

      const a = autorizacionesData.filter((autorizacion) => autorizacion.IdTipo === 13 || autorizacion.IdTipo === 14 || autorizacion.IdTipo === 15 )
      const b = autorizacionesData.filter((autorizacion) => autorizacion.IdPermisoGeneral === 6 )
      setAutorizaciones(MateriaPrima === 1 ? b : a);
    }
  }

  // CAMBIAR FIRMAS DE FINANZAS Y GERENTE PLANTA 
  const handleCheckboxChange = async (event, data, IdPermisoGeneral, NombrePermiso) => {
    const dataToSend = data.map((item) => {
        return {
                IdRequisaDet: item?.IdRequisaDet,
                IdPermisoGeneral: IdPermisoGeneral,
                Autorizo: !item[NombrePermiso],
                IdUsuarioAutorizo: userAuth?.IdUser
            }
    });
    confirmDialog({
        message: `¿Está seguro que desea liberar ${data.length} ${data.length > 1 ? 'permisos' : 'permiso'}?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async() => {
          const respuestaDetalles = await ChangeAuthRequisaMaterial(dataToSend);
          if (respuestaDetalles[0]?.ESTADO === 1) {
            toastShow(toast,"success", "Guardado", respuestaDetalles[0].MENSAGE);
            getInfo()
          } else {
            toastShow( toast, "error", "Error", respuestaDetalles[0].MENSAGE);
          }
        },
        reject: () => {}
    });
    setSelectedDetalle([]);
  };

  const columns = [
    {
      // Comment
      field: "IdRequisaDet",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      body: (rowData) => rowData.IdRequisaDet,
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },
    {
      // Comment
      field: "FechaDet",
      header: "Fecha",
      headerEn: "Date",
      className: "colum-width-medium",
      body: (rowData) => rowData.FechaDet,
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      // cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      // PurchaseRequest
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.Requisa);
      },
      filter: false,
      initialFilterModel: true
    },
    {
      // Comment
      field: "CodigoProducto",
      header: "Codigo",
      headerEn: "Code",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      // Comment
      field: "DescripcionProducto",
      header: "Descripción Producto",
      headerEn: "Description",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small",
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      // Comment
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "small",
      body: (rowData) => rowData.UnitName,
    },
    {
      field: "NumeroIngreso",
      header: "Ingreso",
      headerEn: "Income",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setIngresoToShow(data?.NumeroIngreso)
        setShowDialog2(true)
      },
    },
    {
      header: "Activo",
      headerEn: "Active",
      field: "NombreActivo",
      hidden: MateriaPrima === 1,
      className: "XXlarge",
    },
    {
      header: "Código Activo",
      headerEn: "Active Code",
      field: "CodigoActivo",
      hidden: MateriaPrima === 1,
      className: "small",
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
      hidden: MateriaPrima === 1,
      className: "small",
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
      hidden: MateriaPrima === 1,
      className: "small",
    },

    // {
    //   // Comment
    //   field: "UnitSimbol",
    //   header: "Simbolo Unidad",
    //   headerEn: "Unit Symbol",
    //   className: "small",
    //   body: (rowData) => rowData.UnitSimbol,
    // },
    {
      // Comment
      field: "UserNameAutorizoSolicita",
      header: "Autorizó Gerente Area",
      headerEn: "Unit",
      className: "medium",
    },
    {
      field: "FechaLiberar",
      header: "Fecha Auth. Gerente Area",
      className: "medium",
      Format:'DateTime'
    },
    {
      header: "Cantidad",
      headerEn: "Amount",
      Sumary: "sum",
      field: "Qty",
      className: "Xsmall",
      Format: "Currency",
    },
    // {
    //   // Comment
    //   field: "UserNameAutorizoRRHH",
    //   header: "Autorizó RRHH",
    //   headerEn: "Unit",
    //   className: "medium",
    // },
    // {
    //   // Comment
    //   field: "UserNameAutorizoMASS",
    //   header: "Autorizó MASS",
    //   headerEn: "Unit",
    //   className: "medium",
    // },
    {
      field: "PrecioL",
      header: "Precio L",
      headerEn: "Price L",
      Sumary: "sum",
      Format: "Currency",
      className: "small",
      hidden: hiddenVerPrecios,
    },
    {
      field: "PrecioD",
      Sumary: "sum",
      header: "Precio D",
      headerEn: "Price D",
      Format: "Currency",
      className: "small",
      hidden: hiddenVerPrecios,
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Monto L",
      Sumary: "sum",
      Format: "Currency",
      className: "small",
      hidden: hiddenVerPrecios,
    },
    {
      field: "MontoD",
      header: "Monto D",
      headerEn: "Monto D",
      Sumary: "sum",
      Format: "Currency",
      className: "small",
      hidden: hiddenVerPrecios,
    },

    ...Autorizaciones.map((autorizacion) => {
      const isHidden =
        userAuth.IdRol === 1 ||
        ((autorizacion.IdPermisoGeneral !== 6 || hiddenliberarRequisaM) &&
         (autorizacion.IdPermisoGeneral !== 7 || hiddenAprobarRRHH) &&
         (autorizacion.IdPermisoGeneral !== 8 || hiddenAprobarMASS));
    
      if (IdPermisoGeneral) {
        return {
          field: autorizacion?.NombrePermiso,
          header: autorizacion.NombrePermiso,
          frozen: true,
          alignFrozen: "right",
          align: "center",
          className: "Xsmall",
          Format: "Checkbox",
          filter: false,
          editable: false,
          hidden: isHidden,
          onChange: (event, { data }) => {
            if (autorizacion?.IdPermisoGeneral === IdPermisoGeneral) {
              if (selectedDetalle.length === 0) {
                handleCheckboxChange(
                  event,
                  [data],
                  autorizacion?.IdPermisoGeneral,
                  autorizacion.NombrePermiso
                );
              } else {
                handleCheckboxChange(
                  event,
                  selectedDetalle,
                  autorizacion?.IdPermisoGeneral,
                  autorizacion.NombrePermiso
                );
              }
            }
          },
        };
      } else {
        return {
          field: autorizacion?.NombrePermiso,
          header: autorizacion.NombrePermiso,
          frozen: true,
          alignFrozen: "right",
          Format: "Template",
          align: "center",
          className: "Xsmall",
          filter: false,
          editable: false,
          hidden: isHidden,
          body: (rowData) => {
            return rowData.IdRequisaDet ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '2px' }}>
                <Checkbox checked={rowData[autorizacion?.NombrePermiso] === 1} />
              </div>
            ) : null;
          },
        };
      }
    })
    

  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    loading: loading,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
    showModal: e => showModal(e),
    initialFilterModel: Referencia
      ? {
        Requisa: {
          type: 'equals',
          filter: Referencia,
        },
      }
      : null,
  };

  useEffect(() => {
    obtenerAutorizaciones();
  }, [IdPermisoGeneral]);


  const showModal = (tipoModal) => {
    if (tipoModal === 'ingreso') {
      setShowDialog(true); 
    } else if (tipoModal === 'ordenCompra') {
      setOrdenDialog(true); 
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        "Hubo un problema al guardar la salida."
      );    
    }
  };

  const Ingreso = (Id) => {
    setIngresoEdit(Id);
    setShowDialog(true);
    // showModal('ingreso'); 
  };

  
  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog2(null);
          setIngresoToShow(null);
        },
        rejectLabel: "No",
        reject: () => {}, 
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog2(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };
  
  return (
    <div style={{ height: "82vh" }}>
      <Toast ref={toast} />
      <AgGrid table={table} />


      <Dialog
        visible={showDialog2}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog2}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>



    </div>
  );
};

export default ListadoRequisasMaterialesDet;
